import { createFileRoute } from '@tanstack/react-router';
import { t } from 'utils/routeTitle';

import WordpressManager from 'component/view/Redirects/WordpressManager';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/manage/$siteId/wordpress')({
  staticData: { routeTitle: t('common.wordpress_management') },
  beforeLoad: requireActivePlan,
  component: WordpressManager,
});
